export const en = {
  // Login Page
  welcomeMessage: 'Welcome to',
  welcomeEmoji: '👋🏻',
  loginSubtitle: 'Please sign-in to your account and start the adventure',
  emailOrUsername: 'Email or Username',
  emailPlaceholder: 'Enter your email or username',
  password: 'Password',
  passwordPlaceholder: '············',
  rememberMe: 'Remember Me',
  forgotPassword: 'Forgot Password?',
  login: 'Login',
  loggingIn: 'Signing in...',
  newUser: 'New on our platform?',
  createAccount: 'Create an account',
  or: 'or',
  characterImage: 'Character Image',
  mask: 'Mask',

  // Navigation
  home: 'Home',
  about: 'About',
  inbox: 'Inbox',
  assistants: 'Assistants',
  knowledgeBases: 'Knowledge Bases',
  personalAssistant: 'Personal Assistant',

  // User Dropdown
  userAlt: 'John Doe',
  userName: 'John Doe',
  userEmail: 'admin@vuexy.com',
  myProfile: 'My Profile',
  settings: 'Settings',
  pricing: 'Pricing',
  faq: 'FAQ',
  logout: 'Logout',

  // Mode Dropdown
  lightMode: 'Light',
  darkMode: 'Dark',
  systemMode: 'System',
  modeTooltip: 'Mode',

  // Footer
  copyrightText: 'Made with',
  copyrightBy: 'by',
  companyName: 'NaqshAVA',
  licenseLink: 'License',
  moreThemesLink: 'More Themes',
  documentationLink: 'Documentation',
  supportLink: 'Support',

  // 401  ٍError
  unauthorized401: 'Authentication failed',

  // 404 Page
  pageNotFoundTitle: 'Page Not Found ⚠️',
  pageNotFoundMessage: "We couldn't find the page you are looking for.",
  backToHome: 'Back to Home',
  notFoundImageAlt: '404 Error Image',

  // Dashboard Pages
  homePage: 'Home Page!',
  aboutPage: 'About Page!',

  // Register Page
  registerTitle: 'Adventure starts here 🚀',
  registerSubtitle: 'Make your app management easy and fun!',
  username: 'Username',
  usernamePlaceholder: 'Enter your username',
  registerEmail: 'Email',
  registerEmailPlaceholder: 'Enter your email',
  agreeToTerms: 'I agree to',
  privacyPolicyTerms: 'privacy policy & terms',
  signUp: 'Sign Up',
  alreadyHaveAccount: 'Already have an account?',
  signInInstead: 'Sign in instead',
  signing: 'Signing Up...',

  // Validation Messages
  usernameMinLength: 'Username must be at least 3 characters',
  usernameMaxLength: 'Username must be less than 20 characters',
  emailRequired: 'Email is required',
  emailInvalid: 'Please enter a valid email',
  passwordMaxLength: 'Password must be less than 50 characters',
  agreeToTermsRequired: 'You must agree to the terms and conditions',
  passwordMinLength: 'Password must be at least 8 characters long.',
  passwordMustContainUppercase: 'Password must contain uppercase English letters.',
  passwordMustContainLowercase: 'Password must contain lowercase English letters.',
  passwordMustContainNumber: 'Password must contain at least one number.',
  passwordMustContainSpecialChar: 'Password must contain at least one special character like @$&.',
  questionRequired: 'Question is required',
  answerRequired: 'Answer is required',
  messageCannotBeEmpty: 'Message cannot be empty',
  titleRequired: 'Title is required',
  knowledgeBaseRequired: 'Please select a knowledge base',
  descriptionRequired: 'Description is required',
  linkRequired: 'Website URL is required',
  atLeastOneQuestionRequired: 'At least one question is required',
  fileRequired: 'File is required',

  // Authentication Messages
  loginSuccess: 'Login successful',
  loginError: 'Login failed. Please check your credentials.',
  registerSuccess: 'Registration successful',
  registerError: 'Registration failed. Please try again.',
  logoutSuccess: 'You have been logged out successfully',
  sessionExpired: 'Your session has expired. Please login again.',
  unauthorized: 'You are not authorized to access this page',

  // Register Page Metadata
  registerPageTitle: 'Register',
  registerPageDescription: 'Create your account and start the adventure',

  // Personal Assistant Page Metadata
  personalAssistantPageTitle: 'Personal Assistant',
  personalAssistantPageDescription:
    'Your intelligent personal assistant to help you with daily tasks and provide smart recommendations',

  // Metadata
  metadataTitle: 'AINO - Next.js Admin Dashboard Template with MUI',
  metadataDescription:
    'AINO - Next.js Admin Dashboard Template with MUI - The most developer-friendly & highly customizable template built on MUI v5.',

  //fileinput
  fileInputDefaultTitle: 'Drag your file here or click to select file',
  fileInputDefaultDescription: 'Upload only on file',
  tagInputPlaceHolder: 'Type and press Enter',
  textUploadHelper:
    'CSV file must include question, answer, and tags columns. {br} (Limit total question and answer characters to 1024)',

  //shared

  setting: 'Settings',
  cancel: 'Cancel',
  agreed: 'Confirm',
  delete: 'Delete',
  yesOfCourse: 'yes of course',
  makeChanges: 'Save Changes',
  agent: 'Agent',
  detail: 'Details',
  back: 'Back',
  submit: 'Submit',
  qa: 'Q&A',
  imageFile: 'Image File',
  question: 'Question',
  answer: 'Answer',
  nextStep: 'Next Step',
  text: 'Text',
  website: 'Website',
  moreSettings: 'More Settings',
  documentation: 'Documentation',
  headerTitle: 'Header Title',
  headerBackground: 'Header Background',
  messageTitle: 'Message Title',
  messageTextColor: 'Message Text Color',
  messageBackground: 'Message Background',
  footerBackground: 'Footer Background',
  chatBackground: 'Chat Background',
  floatingButtonPosition: 'Floating Button Position',
  floatingButtonIcon: 'Floating Button Icon',
  shouldUseAI: 'Use AI',
  shouldUseAIHint: 'If you disable this option, you will be responsible for responding to support messages.',
  buttonColor: 'Button Color',
  bottomLeft: 'Bottom Left',
  bottomRight: 'Bottom Right',
  title: 'Title',
  status: 'Status',
  tags: 'tags',

  //Agents
  noAgentFound:
    "Agents are your <boldLine>smart chatbots</boldLine>! They are designed and easily customized based on your needs and <boldLine>specific data</boldLine>. {br} By connecting to one or more dedicated knowledge bases, Agents learn and provide accurate and targeted responses to create a personalized experience for you. It's time to build your first Agent!",
  createAgent: 'Create Agent',
  createNewAgent: 'Create New Agent',
  connectToKnowledgeBase: 'Connect to Knowledge Base',
  learnAndCreateAgent: 'Learn and Create Agent',
  yourChatBotName: 'Your Chatbot Name:',
  chatBotNameSample: 'Example: Digikala Chatbot',
  textFile: 'Text File',
  knowledgeBaseCratingHelper:
    'At this stage, a knowledge base named Default Knowledge Base will be created for you, and your data will be added to it through the form below and connected to this Agent. Remember, you can add new and diverse data to this knowledge base anytime.',
  acceptableFormatsForTextfile: 'Acceptable formats: pdf, doc, docx, xls, xlsx, md',
  selectedTextForLearning: 'Enter the text you want to learn',
  dataName: 'Data Name:',
  dataNameExample: 'Example: Digikala Data',
  websiteUrl: 'Website URL:',
  websiteUrlSample: 'Example: Digikala Chatbot',
  whatsHappensWhenShowSourceBeTrue:
    'If the “Show Sources” option in Agent settings is enabled, the above website address will be shown to users as the source when using this data.',
  singePageUrl: 'Single Page URL',
  mapPageUrl: 'Sitemap URL',
  singleLink: 'Single Link',
  mapSite: 'Sitemap',
  selectLinkType: 'Specify your data link type',
  checkLink: 'Check Link',
  downloadCsvSample: 'Download Sample',
  csvFileCaption: 'Excel file must include question, answer columns.',
  limitChar: '(Limit total question and answer characters to 1024)',
  uploadCsvFile: 'Upload CSV File',
  dataGroup: 'Data Group',
  addQA: 'Add Question',
  acceptableFormatsForImage: 'Acceptable formats: jpg, jpeg, png',

  usageLimitMessage: 'The usage limit for this feature has been reached.',
  hasNoPlan: 'No active subscription plan found.',
  purchaseSubscriptionToContinue: 'Purchase a subscription plan to continue using Aino.',
  active: 'active',
  notActive: 'not active',

  //KnowledgeBase
  createNew: 'Create New Knowledge Base',
  KnowledgeBaseName: 'Knowledge Base Name',
  thisActionDeleteKnowledgeBase: 'This action will delete the knowledge base and all agents connected to it.',
  editDataGroup: 'Edit Data Group',
  dataGroupId: 'Data Group ID :',
  apiSettings: 'API Settings',
  moreAboutAgentApi: 'Learn more about the Agent API',
  addToSelectedKnowledgeBase: 'Add data to selected knowledge base',
  selectKnowledgeBaseFirst: 'Please select a knowledge base first',
  searchInTitles: 'Search in titles...',
  characterCount: 'Character Count',
  synchronize: 'Synchronize',
  noDataFound: 'No data found',
  description: 'Description',
  path: 'Path',
  type: 'Type',
  failed: 'Failed',
  inProgress: 'In Progress',
  new: 'New',
  successful: 'Successful',
  content: 'Content',

  // Personal Assistant Feature
  startNewChat: 'Start New Chat',
  searchContacts: 'Search Contacts',
  selectContactToStart: 'Select a contact to start a conversation.',
  online: 'Online',
  away: 'Away',
  doNotDisturb: 'Do not disturb',
  offline: 'Offline',
  twoStepVerification: 'Two-step Verification',
  notification: 'Notification',
  inviteFriends: 'Invite Friends',
  deleteAccount: 'Delete Account',
  typeAMessage: 'Type a message',
  chooseCollection: 'select your collection',
  send: 'Send',
  selectContact: 'Select Contact',
  action: 'Action',
  deleteConfirm: 'Are you sure you want to delete this item?',
  yesDelete: 'Yes, Delete',
  apiKey: 'API Key',
  baseUrl: 'Base URL',
  showSource: 'Show Sources',
  apiKeyRequired: 'API key is required',
  baseUrlRequired: 'Base URL is required',
  invalidUrl: 'Must be a valid URL',
  atLeastOneFieldRequired: 'At least one field is required',
  apiError: 'Failed to update settings',
  error: 'Error',
  balance: 'Balance',
  yourBalance: 'Your Balance:',
  passwordsMustNotMatch: 'New password must not be the same as the current password',
  passwordsMustMatch: 'Password and repeated password must match',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  repeatPassword: 'Repeat Password',
  name: 'Name',
  PublishAssistant: 'Publish Assistant',
  Step1: 'To embed this assistant into your website, copy and paste the code below inside the',
  BodyTag: '<body>',
  Step1End: 'section of your HTML file.',
  Step2: 'Once added, the assistant will automatically load on your page and be ready for your users to interact with.',
  Step3: 'You can place it at the bottom of your HTML (before the closing',
  BodyTagEnd: '</body>',
  Step3End: ') for best performance.',
  agentWelcomeMessage: 'Welcome Message',
  collectionTitle: 'Collection Title',
  color: 'Color',
  logo: 'Logo',
  avatar: 'Avatar',
  save: 'Save',
  welcomeMessageMin: 'Welcome message must be at least 5 characters',
  collectionTitleMin: 'Collection title must be at least 2 characters',
  colorInvalid: 'Invalid color format',
  reset: 'Reset',
  savedSuccessfully: 'Saved successfully',
  saveFailed: 'Failed to save',
  customize: 'Customize',
  publish: 'Publish',
  addAgent: 'Add Agent',
  collection: 'Collection',
  promptTemplate: 'Prompt Template',
  view: 'View',
  na: 'N/A',
  agentName: 'Agent Name',
  isPreviouslyUsedPassword:
    'Please choose a different password. This password has already been used by you and is duplicated.',
  somethingWentWrong: 'Something went wrong, please try again later.',
  invalidEmailOrPassword: 'Invalid email or password.',
  KnowledgeBaseSource: 'Knowledge base source',

  //menu
  chatBot: 'Chatbot',
  Agent: 'Agent',
  UnAnsweredQuestion: 'Unanswered Questions',
  PrivateRag: 'Private RAG',
  'Personal Assistant': 'Personal Assistant',
  Setting: 'Setting',
  ContentCreator: 'Content Creator',
  Inbox: 'Inbox',
  Token: 'Token',
  KnowledgeBase: 'Knowledge Base',
  profile: 'Profile',
  firstName: 'First Name',
  lastName: 'Last Name',
  phoneNumber: 'Phone Number',
  phoneNumberInvalid: 'Invalid phone number',
  countryCodeLabel: 'Country code',
  countryCodeHelper: 'Choose your country dialing code',
  countryIran: 'Iran',
  countryCanada: 'Canada',
  countryUnitedStates: 'United States',
  countryUnitedKingdom: 'United Kingdom',
  countryGermany: 'Germany',
  countryFrance: 'France',
  countryJapan: 'Japan',
  allowedFileTypes: 'Allowed: JPG, PNG or GIF',
  fileSizeLimit: 'File size must be less than 800KB.',
  uploadNewPhoto: 'Upload New Photo',
  unansweredQuestions: 'Unanswered Questions',
  noUnansweredQuestions: 'No unanswered questions found',
  writeAnswerOfFollowingQuestion: 'Write the answer of the following question:',
  pleaseEnterDesiredAnswer: 'Please enter the desired answer',
  Answered: 'Answered',

  //transactions
  goToPayment: 'Go to Payment',
  price: 'Amount',
  continuePayment: 'Continue to Payment',
  amountMustBeGreaterThan100000: 'Amount must be greater than 1,000,000',
  selectPackageFirst: 'Please select a package first',

  recentTransactions: 'Recent Transactions',
  yourLatestFinancialActivities: 'Your latest financial activities',
  newest: 'Newest',
  oldest: 'Oldest',
  latest: 'Latest',
  noRecentTransactionsFound: 'No recent transactions found.',
  transactionDetails: 'Transaction Details',
  share: 'Share',
  export: 'Export',
  paymentSuccessfullyCompleted: 'Payment Successfully Completed',
  fundsTransferredSecurely: 'Funds have been transferred securely',
  paymentPending: 'Payment Pending',
  paymentIsPending: 'Your payment is pending!',
  paymentUnsuccessful: 'Payment Unsuccessful',
  fundsNotTransferred: 'Funds were not transferred',
  userInformation: 'User Information',
  cardDeposit: 'Card Deposit',
  sourceCardNumber: 'Source Card Number',
  destinationCardNumber: 'Destination Card Number',
  paymentProvider: 'Payment Provider',
  transactionId: 'Transaction ID',
  referenceNumber: 'Reference Number',
  explanation: 'Explanation',
  chatbotChargeMessage: 'This charge was made for asking the following question from the chatbot:',
  currentBalanceAfterTransaction: 'Current Balance After Transaction',
  date: 'Date',
  wallet: 'Wallet',
  transactions: 'Transactions',
  chargeYourAccount: 'Charge Your Account',
  totalBalance: 'Total Balance',
  BadUserNameError: 'The entered username is invalid.',
  DuplicateUserName: 'The username is already in use.',
  DuplicateEmail: 'The username is already in use.',
  aiModelRequired: 'Please select an AI model.',
  aiModel: 'AI Model',
  backToWallet: 'Back to Wallet',
  backToPlans: 'Back to Plans',
  planName: 'Plan Name',

  filters: 'Filters',
  loading: 'Loading...',
  agentPlaceholder: 'Choose your agent',
  statusPlaceholder: 'Select status',
  openChat: 'Open Chats',
  closeChat: 'Closed Chats',
  humanSupport: 'Has Human Support',
  apply: 'Apply',
  connectHumanSupport: 'Connect to Human Support',
  all: 'All',
  seeConversation: 'See Conversation',
  noData: 'No data found',
  agentPageTitle: 'Assistant Details',
  agentPageDesc: 'View full details of your personal assistant',
  inboxPageDesc: 'View your received messages and notifications',
  unansweredQuestionsDesc: 'View all unanswered user questions and manage them efficiently',
  PaymentResultTitle: 'Invoice',
  PaymentResultDescription:
    'The result of your payment has been processed. You can view the full details of the transaction on this page.',
  CheckoutResultTitle: 'Subscription Purchase Result',
  CheckoutResultDescription:
    'The result of your subscription payment has been processed. You can view the full details of the transaction on this page.',
  notEnoughBalance: 'Not Enough Balance',

  // Error Messages
  insufficientBalance: 'Insufficient Balance',
  pleaseRechargeYourAccount: 'Your account balance is too low. Please recharge to continue using the service.',
  recharge: 'Recharge Now',
  networkError: 'Network Error',
  checkYourConnection: 'Please check your internet connection and try again.',
  errorOccurred: 'Error Occurred',
  pleaseTryAgain: 'Something went wrong. Please try again later.',

  //packages
  starterPlan: 'Starter Plan',
  growthPlan: 'Growth Plan',
  professionalPlan: 'Professional Plan',
  starterPlanDesc: '1,000,000 Toman',
  growthPlanDesc: 'Charge your account with 4,500,000 Toman and get 5,000,000 Toman credit!',
  professionalPlanDesc: 'Charge your account with 8,000,000 Toman and get 10,000,000 Toman credit!',
  starterPlanFeature1: 'Access to all Aino features',
  starterPlanFeature2: 'Credit usable in Private RAG, Chatbot, and Content Creator',
  starterPlanFeature3: 'Suitable for testing, small projects, or beginner teams',
  growthPlanFeature1: 'Access to all Aino features',
  growthPlanFeature2: 'Suitable for team use',
  growthPlanFeature3: '10% savings compared to the Starter Plan',
  professionalPlanFeature1: 'Access to all Aino features',
  professionalPlanFeature2: 'Cost-effective and sustainable use',
  professionalPlanFeature3: 'Suitable for large and long-term projects',

  // Error Handler
  accessDenied: 'Access Denied',
  noAccessToResource: "You don't have permission to access this resource.",
  ok: 'OK',
  close: 'Close',

  seePlans: 'see plans',
  notNow: 'Not now',

  fileSizeExceeded: 'The selected file exceeds the maximum allowed size of 1 MB.',
  invalidFile: 'The selected file type is not supported.'
}
